import "./WaitingRoomNotificationCard.css";

const WaitingRoomNotificationCard = ({
  isAdmitting = false,
  isDismissing = false,
  onAdmit,
  onDismiss,
  patient,
}) => {
  if (!patient) return null;

  const patientName =
    patient.patientName ||
    `${patient.firstname ?? ""} ${patient.lastname ?? ""}`.trim() ||
    "Patient";

  return (
    <div className="cm-waiting-room-notification">
      <div className="cm-waiting-room-notification-main">
        <div className="cm-waiting-room-notification-avatar">
          {patient.initials || "?"}
        </div>

        <div className="cm-waiting-room-notification-copy">
          <p className="cm-waiting-room-notification-name">{patientName}</p>
          <p className="cm-waiting-room-notification-status">
            Joined the waiting room
          </p>
        </div>
      </div>

      <div className="cm-waiting-room-notification-actions">
        <button
          className="cm-waiting-room-notification-dismiss"
          disabled={isAdmitting || isDismissing}
          onClick={() => onDismiss(patient.patientId)}
          type="button">
          {isDismissing ? "Dismissing..." : "Dismiss"}
        </button>

        <button
          className="cm-waiting-room-notification-admit"
          disabled={isAdmitting || isDismissing}
          onClick={() => onAdmit(patient.patientId)}
          type="button">
          {isAdmitting ? "Admitting..." : "Admit"}
        </button>
      </div>
    </div>
  );
};

export default WaitingRoomNotificationCard;
